// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* Variables */\n\n/* Mixins */\n.msg-defail-page .outer img {\n  max-width: 100%;\n}\n.msg-defail-page .title {\n  margin-bottom: 50px;\n  font-size: 30px;\n  text-align: center;\n}\n.msg-defail-page .name {\n  margin-bottom: 5px;\n  font-size: 16px;\n}\n.msg-defail-page .sendTime {\n  margin-bottom: 40px;\n  font-size: 14px;\n}", ""]);
// Exports
exports.locals = {
	"theme": "#30B08F",
	"menuBg": "#304156",
	"menuText": "#bfcbd9",
	"menuActiveText": "#409EFF"
};
module.exports = exports;
